import { createBrowserRouter, createMemoryRouter } from 'react-router';

import { CodexPage } from './CodexPage';
import { HomePage } from './HomePage';
import { NotFoundPage } from './NotFoundPage';
import { SettingsPage } from './SettingsPage';
import { LevelSelectPage } from '../features/levels/LevelSelectPage';
import { IS_HOSTED_GAME_PLATFORM } from '../platform/gamePlatform';

const loadGamePage = () =>
  import('../features/game/GamePage').then(({ GamePage }) => ({ Component: GamePage }));
const loadPlaytestPage = () =>
  import('../features/playtest/PlaytestPage').then(({ PlaytestPage }) => ({
    Component: PlaytestPage,
  }));
const loadDailyChallengePage = () =>
  import('../features/daily/DailyChallengePage').then(({ DailyChallengePage }) => ({
    Component: DailyChallengePage,
  }));
const loadChallengeHubPage = () =>
  import('../features/challenges/ChallengeHubPage').then(({ ChallengeHubPage }) => ({
    Component: ChallengeHubPage,
  }));
const loadObjectivesPage = () =>
  import('../features/objectives/ObjectivesPage').then(({ ObjectivesPage }) => ({
    Component: ObjectivesPage,
  }));
const loadSeasonPage = () =>
  import('../features/seasons/SeasonPage').then(({ SeasonPage }) => ({
    Component: SeasonPage,
  }));

export const router = IS_HOSTED_GAME_PLATFORM
  ? createMemoryRouter(
      [
        { path: '/', Component: LevelSelectPage },
        { path: '/levels', Component: LevelSelectPage },
        { path: '/play', lazy: loadGamePage },
        { path: '*', Component: LevelSelectPage },
      ],
      { initialEntries: ['/levels'] },
    )
  : createBrowserRouter([
      { path: '/', Component: HomePage },
      { path: '/levels', Component: LevelSelectPage },
      { path: '/play', lazy: loadGamePage },
      { path: '/codex', Component: CodexPage },
      { path: '/settings', Component: SettingsPage },
      { path: '/daily', lazy: loadDailyChallengePage },
      { path: '/challenges', lazy: loadChallengeHubPage },
      { path: '/objectives', lazy: loadObjectivesPage },
      { path: '/seasons', lazy: loadSeasonPage },
      { path: '/playtest', lazy: loadPlaytestPage },
      { path: '*', Component: NotFoundPage },
    ]);
